import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { FormSubmitHandler } from "../../../common/models";
import { handleFormServerErrors } from "../../../helpers/errorHandling";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import TextInput from "../TextInput";
import { useValidators } from "../../../helpers/validation";
import TextAreaInput from "../TextAreaInput";
import SubmitButton from "../SubmitButton";
import { FlexContent } from "../../layout";
import Icon from "../../icon/Icon";
import { showToast } from "../../../helpers/toastHelpers";

interface SendByEmailFormProps {
  onSubmit: FormSubmitHandler<SendByEmailFormValues>;
  onClose?: () => void;
  documentName: string;
}

export interface SendByEmailFormValues {
  /** @maxLength 100 */
  email: string;
  /** @maxLength 2000 */
  additionalText?: string | null;
}

const SendByEmailForm = (props: SendByEmailFormProps) => {
  const { tError, tInput, tReport, t } = useCustomTranslation();

  const validators = useValidators();

  const methods = useForm<SendByEmailFormValues>({
    defaultValues: {
      email: "",
      additionalText: "",
    },
    mode: "onBlur",
  });

  const onSubmit: SubmitHandler<SendByEmailFormValues> = async (data) => {
    try {
      await props.onSubmit(data);
      showToast(tReport("report_sent_successfully"), "success");
      props.onClose?.();
    } catch (e) {
      handleFormServerErrors(e, tError, methods.setError);
    }
  };

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          name="email"
          type="email"
          required
          placeholder={tInput("delivery_email")}
          options={{
            required: validators.required,
            maxLength: validators.maxLength(100),
          }}
          className="mb-2"
        />
        <TextAreaInput
          name="additionalText"
          placeholder={tInput("your_message")}
        />
        <FlexContent>
          <FlexContent className="border-gray-accent gap-2 rounded-[10px] border px-4 py-3 text-[14px]/[21px]">
            <Icon name="paperclip" size="small" />
            {props.documentName}
          </FlexContent>
          <SubmitButton label={t("send")} icon="arrow-right" />
        </FlexContent>
      </form>
    </FormProvider>
  );
};

export default SendByEmailForm;
